import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function updateStockReceiptRemark(id, payload) {
  const { data: raw } = await request.patch(
    `/ims/stock-receipt/${id}/remark`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
